import { z } from 'zod';

export const RiskReportsSchema = z.object({
    id: z.string().optional(),
    reportName: z.string().min(1),
    generatedAt: z.string().or(z.date()),
    data: z.any().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateRiskReportsSchema = RiskReportsSchema.omit({ id: true });
export const UpdateRiskReportsSchema = RiskReportsSchema;